var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPlanilha(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 49,
    height: 57,
    viewBox: "0 0 49 57",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1 21.262C1 11.7112 1 6.9345 3.81875 3.96725C6.6375 1 11.175 1 20.25 1H28.5C37.575 1 42.1125 1 44.9313 3.97C47.75 6.93175 47.75 11.7085 47.75 21.2592V35.7352C47.75 45.286 47.75 50.0628 44.9313 53.03C42.1125 55.9973 37.575 56 28.5 56H20.25C11.175 56 6.6375 56 3.81875 53.03C1 50.0683 1 45.2915 1 35.7408V21.262Z",
    stroke: "#4A8FB7",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.375 1L13.6005 2.35575C14.1505 5.6475 14.4255 7.29475 15.5805 8.27375C16.73 9.25 18.3993 9.25 21.7378 9.25H27.0095C30.3453 9.25 32.0145 9.25 33.1695 8.27375C34.3245 7.29475 34.5995 5.6475 35.1467 2.35575L35.375 1M13.375 39.5H24.375M13.375 25.75H35.375",
    stroke: "#4A8FB7",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlanilha);
export default __webpack_public_path__ + "static/media/planilha.2a7926f6cb5057f0158e199e20e5fc74.svg";
export { ForwardRef as ReactComponent };